import { render, staticRenderFns } from "./JSONParser.vue?vue&type=template&id=3dc29ba8&scoped=true&"
import script from "./JSONParser.vue?vue&type=script&lang=js&"
export * from "./JSONParser.vue?vue&type=script&lang=js&"
import style0 from "./JSONParser.vue?vue&type=style&index=0&id=3dc29ba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc29ba8",
  null
  
)

export default component.exports